export default "__VITE_ASSET__DzrE5$Gc__"